import React from "react";
import { KeyRound, Trash2 } from "lucide-react";
import Toggle from "@/components/admin/Toggle";

/**
 * One row in the users table.
 *
 * onPatch(id, fields)   — patches show_prices / active toggles
 * onReset(id, email)    — triggers password reset flow
 * onDelete(id, email)   — soft-disable the user
 */
export default function UserRow({ user, onPatch, onReset, onDelete }) {
  return (
    <tr
      className="border-t border-mist"
      data-testid={`admin-user-row-${user.email}`}
    >
      <td className="py-4 pr-4 font-display">{user.email}</td>
      <td className="py-4 pr-4 eyebrow text-brass" style={{ fontSize: 11 }}>
        {user.role}
      </td>
      <td className="py-4 pr-4">
        <Toggle
          on={user.show_prices}
          onChange={(v) => onPatch(user.id, { show_prices: v })}
          testid={`toggle-prices-${user.email}`}
        />
      </td>
      <td className="py-4 pr-4">
        <Toggle
          on={user.active}
          onChange={(v) => onPatch(user.id, { active: v })}
          testid={`toggle-active-${user.email}`}
        />
      </td>
      <td className="py-4 pr-4 text-charcoal/65">
        {user.created_at ? new Date(user.created_at).toLocaleDateString() : "—"}
      </td>
      <td className="py-4 pr-4 text-charcoal/65">
        {user.last_login ? new Date(user.last_login).toLocaleDateString() : "—"}
      </td>
      <td className="py-4 pr-0">
        <div className="flex gap-3 justify-end">
          <button
            type="button"
            onClick={() => onReset(user.id, user.email)}
            className="inline-flex items-center gap-1.5 eyebrow text-charcoal/65 hover:text-brass"
            title="Reset password"
            data-testid={`reset-pw-${user.email}`}
          >
            <KeyRound size={13} /> Reset
          </button>
          <button
            type="button"
            onClick={() => onDelete(user.id, user.email)}
            className="inline-flex items-center gap-1.5 eyebrow text-charcoal/65 hover:text-brass"
            title="Disable user"
            data-testid={`disable-${user.email}`}
          >
            <Trash2 size={13} /> Disable
          </button>
        </div>
      </td>
    </tr>
  );
}
